import React from 'react'
import { format } from 'date-fns'
import { Box, Flex, Text, HStack } from '@chakra-ui/react'

import SystemMessageWrapper from './wrapper'
import SystemMessageCTA from './call-to-action'
import SystemMessageCallMedia from './call-media'
import { parseMessageText } from '../message-helpers'
import { useMessageProperties } from '../message-provider'
import MessageErrors from '../message-errors'
import { Spacer } from '@chakra-ui/react'
import PreviewTag from './preview-tag'
import MaybeMissingText from '~components/shared/texts/maybe-missing-text'
import { MessageMethod } from '~graphql/generated/graphql'
import NotificationEmailPreviews from '~components/engagement/notification-logs/notification-log-row/notification-email-preview'
import NotificationPostcardPreviews from '~components/engagement/notification-logs/notification-log-row/notification-postcard-preview'
import DotSeparator from '~components/shared/detail/dot-separator'
import { MessageLocationTag } from '../index'
import MessageActions from '../../message-actions'

export default function SystemMessage({
    showLocationTag,
}: {
    showLocationTag?: boolean
}) {
    const { message, chat } = useMessageProperties()

    const isEmail = !!message.message_methods?.includes(MessageMethod.Email)
    const isPostcard = !!message.message_methods?.includes(
        MessageMethod.Postcard,
    )
    const notifications =
        message.message_notification_templates?.map(
            mnt => mnt.notification_template,
        ) || []

    return (
        <SystemMessageWrapper
            patient={message.patient}
            isPreview={message.is_preview}
            showLocationTag={showLocationTag}
        >
            <Box w="full">
                <Flex alignItems="center" justifyContent="space-between">
                    {/* {message.is_preview && <PreviewTag mr={1} />} */}
                    <Text fontWeight="medium" fontSize="xs" color="gray.600">
                        {message.is_preview ? 'Preview' : 'System'} Message
                    </Text>
                    {!!notifications.length && (
                        <>
                            <DotSeparator mx={1} fontSize="xs" />
                            <Text fontSize="xs">
                                {notifications.map(n => n.name).join(', ')}
                            </Text>
                        </>
                    )}
                    {showLocationTag && (
                        <Box ml={1}>
                            <MessageLocationTag />
                        </Box>
                    )}
                    <Spacer />
                    <HStack>
                        <MessageErrors />
                        {!showLocationTag && (
                            <MessageActions message={message} chat={chat} />
                        )}
                    </HStack>
                </Flex>
                <Box>
                    {(!isEmail || (message.text && !message.template_data)) && (
                        <MaybeMissingText whiteSpace="pre-wrap">
                            {parseMessageText({
                                text: message.text,
                            })}
                        </MaybeMissingText>
                    )}
                    {isEmail && <NotificationEmailPreviews message={message} />}
                    {isPostcard && (
                        <NotificationPostcardPreviews message={message} />
                    )}
                    <SystemMessageCTA message={message} />
                    <SystemMessageCallMedia message={message} />
                </Box>
            </Box>
        </SystemMessageWrapper>
    )
}

function MethodAndTime() {
    const { message } = useMessageProperties()

    return (
        <Text fontSize="xs" color="gray.500">
            Sent {format(message.created_at, 'p PPP')} via{' '}
            {message.message_methods?.join(' & ') || 'Chckvet only'}
        </Text>
    )
}
